module.exports = __webpack_public_path__ + "img/RankingJP.03b1b872.png";